import {put} from "redux-saga/effects";
import {handleMaintenance} from "../features/maintenance-page/redux/actions";

const { NODE_ENV, REACT_APP_PROD_API_URL } = process.env;
const { protocol, host } = window.location;
const endpoint = `${protocol}//${host}/api`;

const bookingSiteUrl = NODE_ENV === 'development' ? `${REACT_APP_PROD_API_URL}` : endpoint;

function* CallApi(body) {
  const response = yield fetch(`${bookingSiteUrl}`, {
    method: 'post',
    body: JSON.stringify(body)
  });

  const json = yield response.json();
  if (json.isMaintenance) {
    return yield put(handleMaintenance(true));
  } else {
    yield put(handleMaintenance());
    return {data: json}
  }

}

export { CallApi }
